module.exports = __webpack_public_path__ + "static/media/radiation-alt.dc4374b0.svg";